import { errorMessagesListFromResponse } from '../../../../../helpers/errors';
import { useAsyncValue } from '../../../../../hooks';
import { post } from '../../../../../redux/api';
import type { CreateGroupRequest, CreateGroupResponse } from '../../../../../../shared/releaseGroups';
import type { FailedFetchResponse } from '../../../../../helpers/errors';

const createReleaseGroup = async (req: CreateGroupRequest) => {
  return post<CreateGroupRequest, CreateGroupResponse>('/api/project_group', req);
};

/**
 * useCreateGroup is a hook for creating a new release groups.
 */
function useCreateGroup() {
  const createGroupAsyncValue = useAsyncValue<CreateGroupResponse>(null);

  const onCreateGroup = async (req: CreateGroupRequest) => {
    createGroupAsyncValue.setPending();
    let resp;
    try {
      resp = await createReleaseGroup(req);
      createGroupAsyncValue.setResolve(resp.data as CreateGroupResponse);
    } catch (error: unknown) {
      createGroupAsyncValue.setReject(errorMessagesListFromResponse(error as FailedFetchResponse));
    }

    // Return the response, so we can use the id to create the portal token settings.
    return resp;
  };

  return {
    onCreateGroup,
    onResetErrors: createGroupAsyncValue.empty,
    createGroupResponse: createGroupAsyncValue.value,
    createGroupErrors: createGroupAsyncValue.errors,
    isCreating: createGroupAsyncValue.isLoading,
  };
}

export default useCreateGroup;
